define('views/modules/template/assignment/manager/per-template/assignment-manager-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils', 'bootbox',
    // services
    'services/i18n',
    'services/layout',
    // views
    'views/modules/template/assignment/list/per-template/assignment-list',
    'views/parts/menu/menu-action',
    'views/modules/member/select/member-select-panel',
    'src/views/form-view',
    'views/parts/alert/alert-no-data',
    // parts model
    'models/parts/menu/datepicker',
    // models & collections
    'collections/template/assignments',
    'models/template/assignment',
    // template
    'text!templates/modules/template/assignment/manager/manager-content.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, U, Bootbox,
    // services
    i18n,
    LayoutState,
    // views
    VAssignmentList,
    VMenuAction,
    VMemberSelectPanel,
    VForm,
    VAlertNoData,
    // parts model
    MDatePicker,
    // models & collections
    CTemplateAssignments,
    MTemplateAssignment,
    // template
    TAssignmentManagerContent
) {

    var VAssignmentManagerContent = VForm.extend({
        template: TAssignmentManagerContent,

        regions: {
            list: '.assignment-list',
            menu: '.menu-actions',
            alert: '.alert-no-data',
            root: '.panel-body'
        },

        initialize: function(opt) {

            _.extend(this, {
                group: opt.group,
                profile: opt.profile,
                url: opt.url,
                templateModel: opt.template,
                model: new MTemplateAssignment(),
                assignments: new CTemplateAssignments()
            });

            var view = this.view = {
                menu: new VMenuAction({
                    context: this,
                    onClick: this.onActionClick,
                    collection: new Backbone.Collection([
                        { title: i18n.t('messages:tooltip-assign-template'), content: '<strong>+</strong>', skipTranslation: true, btnClass: 'btn-tc-custom', itemClass: 'big-action', callback: this.onNewAssignmentAction },
                        { title: i18n.t("messages:message-delete-selected-assignments-short"), content: i18n.t("messages:message-delete-selected-assignments-short"), itemClass: 'btn-delete pull-right', style: 'display:none;', icon: 'sl-icon-trash', skipTranslation: true, btnClass: 'btn-tc-custom', callback: this.onDeleteSelectedAssignmentsAction },
                    ]),
                    // tooltip: {
                    //     container: this.regions.root
                    // }
                }),
                list: new VAssignmentList({
                    collection: this.collection,
                    template: opt.template
                }),
                alert: new VAlertNoData({
                    title: 'Assign a template',
                    subtitle: 'Click on + to assign your first template',
                    collection: this.collection
                }),
            };

            this.listenTo(view.list, { 'selected:change': this.onSelectedAssignment });
        },

        render: function() {
            var collection = this.collection;
            this.$el.empty().append(Mustache.render(this.template));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.alert, zone.$alert)
                .assign(view.list, zone.$list);
        },

        /////////////
        // actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onSelectedAssignment: function(selectedCollection) {
            this.view.menu.toggleHiddenButton('.btn-delete', selectedCollection.length > 0);
        },

        onNewAssignmentAction: function() {
            var view = this.view.select;
            if (!view) {
                view = this.view.select = new VMemberSelectPanel({
                    customActions: [
                        new MDatePicker({
                            title: 'Template Start Date',
                            model: this.model,
                            attribute: 'startDate'
                        })
                    ]
                });
                this.listenTo(view, { 'selected:confirm': this.onSelectedConfirm });
            }
            LayoutState.stackInfo(view);
        },

        onDeleteSelectedAssignmentsAction: function() {
            Bootbox.confirm({
                title: i18n.t("Delete selected assignments"),
                message: i18n.t("messages:message-delete-selected-assignments"),
                onEscape: true,
                backdrop: true,
                callback: this.deleteSelectedAssignments,
                context: this,
            });
        },

        deleteSelectedAssignments: function(result) {
            if (result) {
                var selected = this.view.list.getSelectedCollection();
                if (selected.length) {
                    selected.setTemplate(this.templateModel.id)
                        .bulkDestroy({
                            context: this,
                            success: function(response) {
                                this.collection.set(response.collection);
                                this.view.list.reset();
                            }
                        });
                }
            }
        },

        onSelectedConfirm: function(collection) {
            var model = this.model,
                commonAttributes = {
                    template: this.templateModel.id,
                    group: this.group.id,
                    startDate: this.model.get('startDate')
                };

            if (collection.length === 1) {
                model.reset();
                model.save(_.extend(commonAttributes, { user: collection.first().id }), {
                    context: this,
                    success: function(model) {
                        this.collection.set(model.clone(), { remove: false });
                    }
                });
            } else {
                this.assignments.setTemplate(this.templateModel.id);
                collection.each(function(model) {
                    this.assignments.add(_.extend(commonAttributes, { user: model.id }));
                }, this);
                this.assignments.bulkCreate({
                    context: this,
                    success: function(response) {
                        this.collection.reset(response.collection);
                        this.assignments.reset();
                    }
                });
            }
        },

    });

    return VAssignmentManagerContent;

});

